import { render, staticRenderFns } from "./RegisterProgress.vue?vue&type=template&id=5e78cb26&"
import script from "./RegisterProgress.vue?vue&type=script&lang=js&"
export * from "./RegisterProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports